// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"953894e4","902":"981ad19f"}[chunkId] + ".chunk.css";
};